<template>
  <div id="cardConcentrateMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡集中管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡集中管理列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <!--<<el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <!--<el-form-item label="月卡分组::">
          <el-select v-model="selfGroupID"
                     placeholder="请选择分组"
                     clearable
                     filterable>
            <el-option v-for="item in choiceGroups"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="平台分组名称::">
          <el-select v-model="fPlatGrpID"
                           clearable
                           filterable
                           placeholder="请选择平台分组名称"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in platCardGroups"
                             :key="item.fPlatGrpID"
                             :label="item.fPlatGrpName"
                             :value="item.fPlatGrpID">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item label="关键字::">
          <el-input placeholder="车牌/用户姓名/电话/单位"
                    v-model="searchKeyWord"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="cardQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
          <!--<el-button type="success"
                     size="small"
                     icon="el-icon-download"
                     :loading="download_loading"
                     @click="createTemplate">创建模板</el-button>
          <el-button type="warning"
                     icon="el-icon-upload"
                     size="small"
                     v-if="is_import"
                     @click="importData">导入</el-button>-->
        </el-form-item>
        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     @click="addSyncCard"
                     v-if="is_edit">新增月卡</el-button>
          <el-button type="warning"
                     size="small"
                     @click="batchRechargeCardConcentrate"
                     v-if="is_batchRecharge">批量续费</el-button>
          <!-- <el-dropdown @command="syncAllCard"
                       v-if="is_batch_syn||is_all_syn">
            <el-button size="small"
                       type="primary">
              下发<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="part"
                                v-if="is_batch_syn">批量下发</el-dropdown-item>
              <el-dropdown-item command="all"
                                v-if="is_all_syn">全部下发</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
          <!-- <el-button type="primary"
                     size="small"
                     @click="syncAllCard"
                     v-if="is_syn">批量下发</el-button> -->
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="synCardList"
                      border
                      :row-class-name="tableRowClassName"
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后操作时间">
              </el-table-column>
              <!--<el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="custName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fCardNo"
                               width="80"
                               label="卡号">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               width="80"
                               label="客户月卡分组名称">
              </el-table-column>-->
              <!--<el-table-column-->
              <!--prop="fCustName"-->
              <!--width="80"-->
              <!--label="用户姓名">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
              <!--prop="fCustPhone"-->
              <!--label="用户电话">-->
              <!--</el-table-column>-->
              <el-table-column prop="fCustName"
                               label="用户姓名">
              </el-table-column>
              <el-table-column prop="fPlateList"
                               width="150"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fCardTypeName"
                               width="100"
                               label="月卡类型">
              </el-table-column>
              <el-table-column prop="fPlatGrpName"
                               width="130"
                               label="平台分组名称">
              </el-table-column>
              <el-table-column prop="fCardNo"
                               width="100"
                               label="卡号">
              </el-table-column>
              <!--<el-table-column prop="fAmount"
                               align="right"
                               label="包月金额">
              </el-table-column>-->
              <el-table-column prop="fStartTime"
                               width="150"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fEndTime"
                               width="150"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fCustInfo"
                               label="用户单位">
              </el-table-column>
              <el-table-column prop="fRemSyncCount"
                               align="right"
                               width="130"
                               label="剩余需要同步数量">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="330">
                <template slot-scope="scope">
                  <el-button @click="viewCard(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCard(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <!--<el-button size="mini"-->
                  <!--type="danger"-->
                  <!--@click="editStatus(scope.$index, scope.row)"> {{scope.row.fStatus==='0'?'启用':'禁用'}}</el-button>-->
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCardConcentrateClient(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <!--<el-button size="mini"
                             type="info"
                             @click="synCard(scope.$index, scope.row,true)">下发</el-button>-->
                  <!--<el-popover placement="top">
                    <div style="text-align: left; margin: 0">
                      <el-button size="mini"
                             type="warning"
                             @click="rechargeCardConcentrate(scope.$index, scope.row)"
                             v-if="is_recharge">续费</el-button>
                      <el-button size="mini"
                             type="info"
                             @click="rechargeCardConcentrateSync(scope.$index, scope.row)"
                             v-if="scope.row.recfBigRowID>0">续费下发</el-button>
                    </div>
                    <el-button slot="reference"
                               size="mini">更多操作</el-button>
                  </el-popover>-->
                  <el-button size="mini"
                             type="warning"
                             @click="rechargeCardConcentrate(scope.$index, scope.row)"
                             v-if="is_recharge">续费</el-button>
                </template>
              </el-table-column>
            </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="syncData.title"
               :visible.sync="synDataVisible"
               width="450px"
               v-dialogDrag>
      <el-form label-width="100px"
               :model="syncData"
               :rules="rules"
               ref="ruleForm"
               style="margin-top:20px">
        <el-form-item label="选择客户::"
                      prop="fCustID">
          <el-select v-model="syncData.fCustID"
                     filterable
                     style="width:250px"
                     placeholder="请选择客户">
            <el-option v-for="item in offlineCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-alert :title="syncData.tip"
                type="warning"
                :closable="false"
                show-icon>
      </el-alert>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="sync_loading"
                   @click="syncAllCardOk('ruleForm')">{{sync_msg}}</el-button>
        <el-button @click="synDataVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cardPay"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row height="10px"></el-row>
        <!--<el-row>
          <el-col :span="12">
            <el-form-item label="客户月卡分组名称"
                          prop="fGroupName">
              <el-input v-model="cardPay.fGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡号"
                          prop="fCardNo">
              <el-input v-model="cardPay.fCardNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
        <!--<el-row>
          <el-col :span="12">
            <el-form-item label="客户名称::">
              <el-select v-model="parkCustID"
                        multiple
                        collapse-tags
                        filterable
                        clearable
                        style="width:100%"
                        @change="changeCust"
                        placeholder="请选择客户">
                <el-option v-for="item in parkChoiceCusts"
                          :key="item.fCustID"
                          :label="item.unionName"
                          :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户姓名"
                          prop="fCustName">
              <el-input v-model="cardPay.fCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="绑定车牌"
                          prop="fPlateList">
              <el-input v-model="cardPay.fPlateList"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="月卡类型"
                          prop="fCardTypeName">
              <el-input v-model="cardPay.fCardTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="金额(元)"
                          prop="fPayAmount">
              <el-input v-model="cardPay.fPayAmount"
                        placeholder="请填写金额(元)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="cardPay.fCardTypeID==='40'"
                          label="购买时间(小时)"
                          prop="fPaySecs">
              <el-input v-model="cardPay.fPaySecs"></el-input>
            </el-form-item>
            <el-form-item v-else-if="cardPay.fCardTypeID==='50'"
                          label="购买次数(次)"
                          prop="fPayCount">
              <el-input v-model="cardPay.fPayCount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起始时间"
                          prop="fBatStartTime">
              <el-date-picker v-model="cardPay.fBatStartTime"
                              :disabled="cardPay.fIsEdit===1"
                              style="width:100%"
                              type="datetime"
                              placeholder="选择起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间"
                          prop="fBatEndTime">
              <el-date-picker v-model="cardPay.fBatEndTime"
                              type="datetime"
                              style="width:100%"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="fRemark">
              <el-input v-model="cardPay.fRemark"
                        type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="save_loading"
                   @click="submitForm('ruleForm')">{{save_msg}}</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitleBatch"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisibleBatch">
      <el-form :model="cardPayBatch"
               :rules="rulesBatch"
               ref="ruleFormBatch"
               label-width="140px">
        <el-row height="10px"></el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台分组名称::"
                          prop="fPlatGrpID">
              <el-select v-model="cardPayBatch.fPlatGrpID"
                           filterable
                           placeholder="请选择平台分组名称"
                           class="myCardInput"
                           style="width: 100%">
                  <el-option v-for="item in platCardGroups"
                             :key="item.fPlatGrpID"
                             :label="item.fPlatGrpName"
                             :value="item.fPlatGrpID">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="金额(元)"
                          prop="fPayAmount">
              <el-input v-model="cardPayBatch.fPayAmount"
                        placeholder="请填写金额(元)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="cardPayBatch.fCardTypeID==='40'"
                          label="购买时间(小时)"
                          prop="fPaySecs">
              <el-input v-model="cardPayBatch.fPaySecs"></el-input>
            </el-form-item>
            <el-form-item v-else-if="cardPayBatch.fCardTypeID==='50'"
                          label="购买次数(次)"
                          prop="fPayCount">
              <el-input v-model="cardPay.fPayCount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起始时间::"
                          prop="fBatStartTime">
              <el-date-picker v-model="cardPayBatch.fBatStartTime"
                              :disabled="cardPayBatch.fIsEdit===1"
                              style="width:100%"
                              type="datetime"
                              placeholder="选择起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间::"
                          prop="fBatEndTime">
              <el-date-picker v-model="cardPayBatch.fBatEndTime"
                              type="datetime"
                              style="width:100%"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input v-model="cardPayBatch.fRemark"
                        type="textarea"></el-input>
            <span style="color:red">批量续费后，该分组的月车都被改为批量续费的起始和结束时间</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="save_loading"
                   @click="submitFormBatch('ruleFormBatch')">{{save_msg}}</el-button>
        <el-button @click="dialogFormVisibleBatch = false">取消</el-button>
      </div>
    </el-dialog>
    <cardConcentrateView ref="child"
              :cardActiveName="cardActiveName"
              :choiceCusts="choiceCusts"
              :platCardGroups="platCardGroups"></cardConcentrateView>
  <el-dialog title="导入月卡数据"
               :visible.sync="importDataVisible"
               width="65%"
               top="7vh"
               v-dialogDrag>
      <el-form label-width="120px">
        <!--<el-form-item label="选择客户::">
          <el-select v-model="importModel.fCustID"
                     style="width:250px"
                     filterable
                     @change="changeImportCust"
                     :disabled="importModel.btnOkLoading||importModel.btnLoading"
                     placeholder="请选择::">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="导入excel文件::"
                      style="height:65px;padding-top:20px">
          <el-upload class="upload-demo"
                     action="#"
                     :show-file-list='false'
                     :on-success="uploadSuccess"
                     :http-request="uploadExcel">
            <el-button size="small"
                       type="primary"
                       :disabled="importModel.btnOkLoading"
                       :loading="importModel.btnLoading">{{importModel.btnMsg}}</el-button>
            <div slot="tip"
                 class="el-upload__tip">只能上传Excel文件</div>
          </el-upload>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-table :data="importModel.data"
                      :row-class-name="tableErrorRowClassName"
                      border
                      v-loading="importModel.loading"
                      highlight-current-row
                      style="width: 100%"
                      height="400">
              <el-table-column prop="num"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fPlatGrpID"
                               v-if="false"
                               label="平台分组ID">
              </el-table-column>
              <el-table-column prop="fPlatGrpName"
                               width="105"
                               label="平台分组名称">
              </el-table-column>
              <el-table-column prop="fCardType"
                               v-if="false"
                               label="月卡类型">
              </el-table-column>
              <el-table-column prop="fCardTypeName"
                               width="90"
                               label="月卡类型">
              </el-table-column>
              <el-table-column prop="fCustName"
                               label="用户姓名">
              </el-table-column>
              <el-table-column prop="fPlateList"
                               width="130"
                               label="车牌号码">
              </el-table-column>
              <el-table-column prop="fCustID"
                               v-if="false"
                               label="客户ID">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustNameTemp"
                               v-if="false"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fGroupID"
                               v-if="false"
                               label="客户月卡分组ID">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               width="130"
                               label="客户月卡分组名称">
              </el-table-column>
              <el-table-column prop="fParkID"
                               v-if="false"
                               label="场库ID">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="100"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               v-if="false"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fPlaceNums"
                               width="90"
                               align="right"
                               label="车位数量">
              </el-table-column>
              <el-table-column prop="fCardNo"
                               width="60"
                               label="卡号">
              </el-table-column>
              <el-table-column prop="fCustPhone"
                               label="用户电话">
              </el-table-column>
              <el-table-column prop="fCustCreNo"
                               width="90"
                               label="用户证件号">
              </el-table-column>
              <el-table-column prop="fCarTypeID"
                               v-if="false"
                               label="车辆类型">
              </el-table-column>
              <el-table-column prop="fCarTypeName"
                               label="车辆类型">
              </el-table-column>
              <el-table-column prop="fBatStartTime"
                               width="115"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fBatEndTime"
                               width="115"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fCustInfo"
                               label="用户单位">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注信息">
              </el-table-column>
              <el-table-column label="错误信息"
                               fixed="right">
                <template slot-scope="scope">
                  <el-tooltip placement="left">
                    <div slot="content"
                         v-html="scope.row.fErrorMsg"></div>
                    <span>{{scope.row.fErrorMsg}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row v-if="isError">
          <el-col :span="24">
          <span style="color:red">{{fErrorCount}}条数据存在异常，请查看对应的错误信息</span>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled="importModel.btnOkDisabled"
                   @click="importOk"
                   v-if="is_import"
                   :loading="importModel.btnOkLoading">{{importModel.btnOkMsg}}</el-button>
        <el-button @click="importDataVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cardConcentrateView from '../../components/cardConcentrateView'
// import * as api from '../../api/card'
import { mapActions } from 'vuex'
export default {
  name: 'cardConcentrateMain',
  components: { cardConcentrateView },
  data () {
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_all_syn: false,
      is_batch_syn: false,
      is_export: false,
      is_import: false,
      is_batchRecharge: false,
      importDataVisible: false,
      download_loading: false,
      isError: false,
      fErrorCount: 0,
      importModel: {
        fCustID: '',
        data: [],
        loading: false,
        btnMsg: '点击上传',
        btnLoading: false,
        btnOkDisabled: true,
        btnOkMsg: '确定导入',
        btnOkLoading: false
      },
      synDataVisible: false,
      statusTitle: '',
      export_msg: '导出',
      export_loading: false,
      sync_loading: false,
      sync_msg: '下发',
      navigationMap: {
        cardList: '月卡列表',
        synCardList: '待同步'
      },
      cardActiveName: 'cardList',
      loading: false,
      searchKeyWord: '',
      tableHeight: 0,
      choiceCusts: [],
      platCardGroups: [],
      parkChoiceCusts: [],
      offlineCusts: [],
      choiceGroups: [],
      cardList: [],
      synCardList: [],
      selCustID: '',
      selfGroupID: '',
      pageSize: 20,
      pageNo: 1,
      total: 0,
      syncData: {
        isAll: false,
        tip: '',
        title: '',
        fCustID: ''
      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fPayAmount: [
          { required: true, message: '请选择输入充值金额', trigger: 'change' }
        ],
        fBatStartTime: [
          { required: true, message: '请选择起始时间', trigger: 'change' }
        ],
        fBatEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      rulesBatch: {
        fPlatGrpID: [
          { required: true, message: '请选择平台分组名称', trigger: 'change' }
        ],
        fPayAmount: [
          { required: true, message: '请选择输入充值金额', trigger: 'change' }
        ],
        fBatStartTime: [
          { required: true, message: '请选择起始时间', trigger: 'change' }
        ],
        fBatEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      dialogTitle: '',
      dialogFormVisible: false,
      dialogTitleBatch: '',
      dialogFormVisibleBatch: false,
      save_loading: false,
      save_msg: '保存',
      parkCustID: [],
      cardPay: {
        fBigRowID: '',
        fGroupName: '',
        fCardID: '',
        fCustID: '',
        fCardNo: '',
        fCustName: '',
        fPlateList: '',
        fCardTypeName: '',
        fPayAmount: '',
        fCardTypeID: '',
        fPaySecs: '',
        fPayCount: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fRemark: '',
        fCustTypeID: ''
      },
      fPlatGrpID: '',
      cardPayBatch: {
        fPlatGrpID: '',
        fCardTypeName: '',
        fCardTypeID: '',
        fPayAmount: '',
        fPaySecs: 0,
        fPayCount: 0,
        fBatStartTime: '',
        fBatEndTime: '',
        fRemark: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'getCardGroupByCustId', 'getCustByGroup', 'getPlatCardGroup', 'getCardConcentrateByQuery', 'getParkCust', 'cardConcentrateDataTemplate', 'cardConcentrateDataUpload', 'importCardConcentrateData', 'loadCardConcentrateConcentrateEdit', 'loadCardOtherListConcentrateAdd', 'getParkList', 'saveCardConcentrate', 'getCurrentUserPers', 'cardDataTemplate',
      'deleteCardCardConcentrate', 'synCardConcentrateById', 'setCardStatus', 'loadCardConcentrateTypeList', 'cardConcentrateRecharge', 'cardConcentrateBatchRecharge', 'synCardConcentrateRecharge', 'getCardConcentrateRechargeSync', 'loadCarTypeList', 'getRechargeList', 'getCardPayList', 'getCarPresnetList', 'cardUpload', 'importCardData', 'exportCardConcentrateData'
    ]),
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    uploadExcel (file) {
      // if ((this.importModel.fCustID || '').trim().length <= 0) {
      // this.$message.error('提示：请先选择客户!')
      // return
      // }
      var exts = ['.xls', '.xlsx']
      var fileExt = file.file.name.substring(file.file.name.lastIndexOf('.')).toLowerCase()
      const isJPG = exts.indexOf(fileExt) !== -1
      const isLt500k = file.file.size / 1024 < 500

      if (!isJPG) {
        this.$message.error('提示：上传文件只能是 xls/xlsx 格式!')
        return
      }
      if (!isLt500k) {
        this.$message.error('提示：上传图片大小不能超过 500KB!')
        return
      }
      this.importModel.btnOkDisabled = true
      this.importModel.data = []
      this.importModel.loading = true
      this.importModel.btnLoading = true
      this.importModel.btnMsg = '导入中……'
      let data = new FormData()
      data.append('cradFile', file.file)
      data.append('fCustID', this.importModel.fCustID)
      this.cardConcentrateDataUpload(data).then(res => {
        // this.importModel.custDisabled = false
        this.importModel.btnLoading = false
        this.importModel.btnMsg = '点击上传'
        this.importModel.loading = false
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            var importData = data.Data.data || []
            this.importModel.data = importData
            this.fErrorCount = data.Data.fErrorCount
            this.isError = data.Data.isError
            if (importData.filter(r => r.fIsErr === false).length > 0) {
              this.importModel.btnOkDisabled = false
            }
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    importData () {
      if (this.importModel.btnMsg !== '导入中……' && this.importModel.btnOkMsg !== '导入中……') {
        this.importModel.fCustID = ''
        this.importModel.data = []
        this.importModel.btnOkDisabled = true
      }
      this.isError = false
      this.importDataVisible = true
    },
    createTemplate () {
      this.download_loading = true
      this.cardConcentrateDataTemplate().then(res => {
        this.download_loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, '集中月卡导入模板.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    importOk () {
      var data = this.importModel.data.filter(r => r.fIsErr === false)
      this.importModel.btnOkLoading = true
      this.importModel.btnOkMsg = '导入中……'
      this.importCardConcentrateData({ fCustID: this.importModel.fCustID, data: data }).then(res => {
        this.importModel.btnOkLoading = false
        this.importModel.btnOkMsg = '确定导入'
        this.importModel.btnOkDisabled = true
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.$message({
              type: 'success',
              message: data.Msg
            })
            this.initData()
            if (data.Data.length > 0) {
              this.importModel.data = data.Data
            } else {
              this.importDataVisible = false
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.exportCardConcentrateData({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        searchKeyWord: this.searchKeyWord,
        cardActiveName: this.cardActiveName,
        isExport: 1,
        fPlatGrpID: this.fPlatGrpID
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_月卡集中管理数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    batchRechargeCardConcentrate () {
      var today = new Date()
      var startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      var endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      this.cardPayBatch = {
        fPlatGrpID: '',
        fCardTypeName: '',
        fCardTypeID: '',
        fPayAmount: '',
        fPaySecs: 0,
        fPayCount: 0,
        fBatStartTime: this.$dateFormat(startTime, 'yyyy-MM-dd hh:mm:ss'),
        fBatEndTime: this.$dateFormat(endTime, 'yyyy-MM-dd hh:mm:ss'),
        fRemark: ''
      }
      if (this.$refs['ruleFormBatch']) {
        this.$refs['ruleFormBatch'].clearValidate()
      }
      this.dialogTitleBatch = '批量续费'
      this.dialogFormVisibleBatch = true
    },
    submitFormBatch (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cardPayBatch.fBatStartTime instanceof Date) {
            this.cardPayBatch.fBatStartTime = this.$dateFormat(this.cardPayBatch.fBatStartTime, 'yyyy-MM-dd hh:mm:ss')
          }
          if (this.cardPayBatch.fBatEndTime instanceof Date) {
            this.cardPayBatch.fBatEndTime = this.$dateFormat(this.cardPayBatch.fBatEndTime, 'yyyy-MM-dd hh:mm:ss')
          }
          this.$confirm('批量续费将为该平台分组下所有的客户的月卡进行续费, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.save_loading = true
            this.save_msg = '保存中…'
            this.cardConcentrateBatchRecharge(this.cardPayBatch).then(res => {
              this.save_loading = false
              this.save_msg = '保存'
              if (res && res.data) {
                var data = res.data
                if (data.IsOk) {
                  this.dialogFormVisibleBatch = false
                  this.$message({
                    type: 'success',
                    message: data.Msg
                  })
                  this.initData()
                } else {
                  this.$message.error('提示：' + data.Msg)
                }
              }
            })
          })
        }
      })
    },
    rechargeCardConcentrate (index, row) {
      this.parkCustID = []
      this.getParkCust({
        fCardID: row.fCardID
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parkChoiceCusts = data.Data.parkCust || []
              if (data.Data.bingParkCust.length > 0) {
                (data.Data.bingParkCust || []).forEach(item => {
                  this.parkCustID.push(item)
                })
              }
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
      var fBatStartTime = new Date(row.ncdEndTime)
      var fBatEndTime = new Date(row.fEndTime)
      fBatEndTime = new Date(fBatEndTime.setMonth(fBatEndTime.getMonth() + 1))
      this.cardPay = {
        fCardID: row.fCardID,
        fCustID: row.fCustID,
        recfBigRowID: 0,
        fCardNo: row.fCardNo,
        fCustName: row.fCustName,
        fPlateList: row.fPlateList,
        fCardTypeName: row.fCardTypeName,
        fCardTypeID: row.fCardTypeID,
        fGroupName: row.fGroupName,
        fPayAmount: '',
        fPaySecs: 0,
        fPayCount: 0,
        fBatStartTime: this.$dateFormat(fBatStartTime, 'yyyy-MM-dd hh:mm:ss'),
        fBatEndTime: this.$dateFormat(fBatEndTime, 'yyyy-MM-dd hh:mm:ss'),
        fRemark: '',
        fCustTypeID: row.fCustTypeID,
        fIsEdit: 0
      }
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
      this.dialogTitle = row.fCustName + '-' + '【' + row.fPlateList + '】' + '-续费'
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cardPay.fBatStartTime instanceof Date) {
            this.cardPay.fBatStartTime = this.$dateFormat(this.cardPay.fBatStartTime, 'yyyy-MM-dd hh:mm:ss')
          }
          if (this.cardPay.fBatEndTime instanceof Date) {
            this.cardPay.fBatEndTime = this.$dateFormat(this.cardPay.fBatEndTime, 'yyyy-MM-dd hh:mm:ss')
          }
          this.save_loading = true
          this.save_msg = '保存中…'
          this.cardConcentrateRecharge(this.cardPay).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    cardQuery () {
      this.initData()
      // let obj = {}
      // obj = this.choiceCusts.find((item) => {
      //   return item.fCustID === this.selCustID
      // })
      // this.custName = obj.unionName
    },
    viewCard (row) {
      this.$refs.child.viewCard(row)
    },
    addSyncCard () {
      this.$refs.child.addSyncCard()
    },
    editCard (index, row) {
      this.$refs.child.editCard(index, row)
    },
    deleteCardConcentrateClient (index, row) {
      this.$confirm('删除客户【' + row.fCustName + '】的月卡车【' + row.fPlateList + '】记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteCardCardConcentrate({ fCardID: row.fCardID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    editStatus (index, row) {
      let msg = '请确认选中月卡是否 '
      msg += (row.fStatus === '0' ? '启用' : '禁用' + '？')
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.cardActiveName = this.cardActiveName
        this.setCardStatus({ fCardID: row.fCardID, fStatus: row.fStatus }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          }
        })
      })
    },
    syncAllCard (e) {
      if (e === 'all') {
        this.syncData.title = '全部下发'
        this.syncData.tip = '将所选客户下的【所有月卡及待同步】数据下发到线下'
        this.syncData.isAll = true
      } else {
        this.syncData.title = '批量下发'
        this.syncData.tip = '将所选客户下的所有【待同步月卡】数据下发到线下'
        this.syncData.isAll = false
      }
      this.syncData.fCustID = ''
      this.synDataVisible = true
    },
    syncAllCardOk (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tmpCust = this.choiceCusts.filter(item => {
            if (item.fCustID === this.syncData.fCustID) { return item }
          })
          var tip = '将客户[' + tmpCust[0].fCustName + ']的' + (this.syncData.isAll ? '【所有月卡及待同步】' : '【待同步月卡】') + '数据 ，从云平台批量下发同步到线下客户端, 是否继续?'
          this.$confirm(tip, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            this.sync_loading = true
            this.sync_msg = '下发中……'
            this.synCardConcentrateById({
              fCustID: this.syncData.fCustID,
              fIsAll: this.syncData.isAll
            }).then(res => {
              this.sync_loading = false
              this.sync_msg = '下发'
              if (res && res.data) {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '操作完成'
                    })
                    this.synDataVisible = false
                  } else {
                    this.$message.error('提示：' + data.Msg)
                  }
                }
              }
            })
          }).catch(() => { })
        }
      })
    },
    rechargeCardConcentrateSync (index, row, isSyn) {
      // if (row.fRemSyncCount === '0') {
      // var message = ''
      // message = '没有需要同步的数据'
      // this.$message.error(message)
      // return false
      // }
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将月车[' + row.fPlateList + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.synCardConcentrateRecharge({
            fBigRowID: row.recfBigRowID,
            fCardID: row.fCardID
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }).catch(() => { })
      }
    },
    synCard (index, row, isSyn) {
      if (row.fRemSyncCount === '0') {
        var message = ''
        message = '没有需要同步的数据'
        this.$message.error(message)
        return false
      }
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将月车[' + row.fPlateList + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.synCardConcentrateById({
            fCardID: row.fCardID,
            fIsAll: false
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }).catch(() => { })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    initData () {
      var isSyn = this.cardActiveName === 'synCardList'
      if (isSyn) {
        this.synCardList = []
      } else {
        this.cardList = []
      }
      this.loading = true
      this.getCardConcentrateByQuery({
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        fPlatGrpID: this.fPlatGrpID,
        searchKeyWord: this.searchKeyWord,
        cardActiveName: this.cardActiveName
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              if (isSyn) {
                this.synCardList = data.Data.rows
                this.cardList = data.Data.rows
              } else {
                this.synCardList = data.Data.rows
                this.cardList = data.Data.rows
              }
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    }
  },

  watch: {

  },
  computed: {
    ispagination: function () {
      return this.total > this.pageSize
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 26300 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
            this.is_recharge = data.Data.data.is_recharge
            this.is_import = data.Data.data.is_import
            this.is_batchRecharge = data.Data.data.is_batchRecharge
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
            this.offlineCusts = custs.filter(r => r.fCustTypeID === '0') // 封闭式客户
          }
        }
      }
    })
    this.getPlatCardGroup().then(response => {
      if (response.data) {
        let { status, data } = response
        if (status === 200) {
          if (data.IsOk) {
            this.platCardGroups = data.Data
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#cardConcentrateMain .is-disabled .el-input__inner,
#cardConcentrateMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#cardConcentrateMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cardConcentrateMain .el-dialog__title {
  color: white;
}
#cardConcentrateMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cardConcentrateMain .el-dialog__body {
  padding: 5px;
}
#cardConcentrateMain .warning-row {
  color: chocolate;
}
#cardConcentrateMain .error-row {
  color: #fb4545;
}
</style>
<style scoped>
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/card/cardConcentrateMain.vue